export const IS_DEV = process.env.REACT_APP_ENVIRONMENT === 'develop'
export const IS_PROD = process.env.REACT_APP_ENVIRONMENT === 'production'
